<div class="grid grid-cols-2 gap-3">
  <app-details-view label="Identyfikator">
    {{ id() }}
  </app-details-view>

  <app-details-view label="Numer zwrotu">
    {{ number() }}
  </app-details-view>

  <app-details-view label="Numer zlecenia dostawy">
    @if (isNotNil(shippingNumber())) {
      {{ shippingNumber() }}
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Numer zamówienia">
    @if (isNotNil(orderNumber())) {
      <div
        pTooltip="Kliknij, aby wyświetlić szczegóły"
        role="button"
        (click)="handleShowOrderDetailsClick()">
        <div class="text-[#3858E9] underline decoration-dotted">
          {{ orderNumber() }}
        </div>
      </div>
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Data utworzenia">
    <app-date [date]="createdAt()" />
  </app-details-view>

  <app-details-view label="Data zatwierdzenia">
    @if (isNotNil(approvedAt())) {
      <app-date [date]="approvedAt()!" />
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Data odrzucenia">
    @if (isNotNil(rejectedAt())) {
      <app-date [date]="rejectedAt()!" />
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Data zwrotu">
    <app-date [date]="restockedAt()" />
  </app-details-view>

  <app-details-view label="Imię i nazwisko">
    @if (shouldShowPersonValue(personDignity())) {
      {{ personDignity() }}
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Adres e-mail">
    @if (shouldShowPersonValue(personEmail())) {
      {{ personEmail() }}
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Numer telefonu">
    @if (shouldShowPersonValue(personPhone())) {
      {{ personPhone() }}
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Status">
    <app-warehouse-restock-status [status]="status()" />
  </app-details-view>

  <app-details-view label="Rodzaj zwrotu">
    <app-warehouse-restock-type [type]="type()" />
  </app-details-view>

  <div class="col-span-2">
    <app-details-view label="Komentarz">
      @if (isNotNil(comment())) {
        {{ comment() }}
      } @else {
        <app-no-data />
      }
    </app-details-view>
  </div>
</div>
